import { CommonHelper } from '../helpers/common';
import { BattingStatisticsModel } from "./BattingStatistics";
import { InningModel } from "./Inning";
import { LinescoreModel } from "./Linescore";
import { PitchingStatisticsModel } from "./PitchingStatistics";
import { PlaybyplayModel } from "./Playbyplay";
import { PlayerModel } from "./Player";

export class BoxscoreModel {
    id: number = 0;
    title: string = '';
    date: Date = new Date();
    linescore: LinescoreModel = new LinescoreModel();
    playbyplays: PlaybyplayModel[] = [];
    activities: {
        label: string,
        value: string
    }[] = [];
    awayBatters: PlayerModel[] = [];
    awayPitchers: PlayerModel[] = [];
    homeBatters: PlayerModel[] = [];
    homePitchers: PlayerModel[] = [];
    batter: PlayerModel = new PlayerModel();
    onDeck: PlayerModel = new PlayerModel();
    inTheHole: PlayerModel = new PlayerModel();
    pitcher: PlayerModel = new PlayerModel();

    private _lineupAwayOrder: number[] = [];
    private _lineupHomeOrder: number[] = [];

    public get awayLineup():PlayerModel[]{
        return this._getPlayerOrders(this._lineupAwayOrder, this.awayBatters);
    }
    public get homeLineup():PlayerModel[]{
        return this._getPlayerOrders(this._lineupHomeOrder, this.homeBatters);
    }

    constructor(obj?: any) {
        if (obj) {
            this.title = obj.title;
            this.date = CommonHelper.getDate(obj.date);
            this.linescore.awayTeam.abbrName = obj.away;
            this.linescore.awayTeam.shortName = obj.awayNameShort;
            this.linescore.awayTeam.name = obj.awayName;
            this.linescore.awayTeam.activities = typeof obj.awayInfo !== 'undefined' ? obj.awayInfo.map( (i: any) => {
                return { 
                    title: i.title,
                    movements :i.fieldList.map( (i2 : any) =>  {
                        return {
                            label:i2.label,
                            value:i2.value
                        }
                    }) }; 
            } ) : [];
            this.linescore.awayTeam.wins =obj.awayW;
            this.linescore.awayTeam.losses =obj.awayL;
            this.linescore.awayTeam.homes = obj.awayH;
            this.linescore.awayTeam.runs = obj.awayR;
            this.linescore.awayTeam.errors =obj.awayE;

            this.linescore.homeTeam.abbrName = obj.home;
            this.linescore.homeTeam.shortName = obj.homeNameShort;
            this.linescore.homeTeam.name = obj.homeName;
            this.linescore.homeTeam.activities = typeof obj.homeInfo !== 'undefined' ? obj.homeInfo.map( (i: any) => {
                return { 
                    title: i.title,
                    movements :i.fieldList.map( (i2 : any) =>  {
                        return {
                            label:i2.label,
                            value:i2.value
                        }
                    }) }; 
            } ) : [];
            this.linescore.homeTeam.wins =obj.homeW;
            this.linescore.homeTeam.losses =obj.homeL;
            this.linescore.homeTeam.homes = obj.homeH;
            this.linescore.homeTeam.runs = obj.homeR;
            this.linescore.homeTeam.errors = obj.homeE;
            
            this.linescore.innings = obj.scores.map( (i: any) => new InningModel(i));
            this.linescore.inningCurrent = this.linescore.innings.length > 0 ? this.linescore.innings[this.linescore.innings.length - 1].inning : 1;
            
            const aAbbr = this.linescore.awayTeam.abbrU;
            const hAbbr = this.linescore.homeTeam.abbrU;
           
            this.awayBatters = typeof obj.batting[aAbbr] !== 'undefined' ? 
            obj.batting[aAbbr].map((i: any) => {
                const player = new PlayerModel(i);
                player.mlbId = typeof i.id !== 'undefined' ? i.id : '';
                player.name = typeof i.name !== 'undefined' ? i.name : '';
                player.jersey = typeof i.jersey !== 'undefined' ? i.jersey : 0;
                player.battingStats = new BattingStatisticsModel(i);
                return player;
            })
            : [];

            if(typeof obj.lineups !== 'undefined' && typeof obj.lineups.away !== 'undefined'){
                this._lineupAwayOrder = obj.lineups.away.map( (l:any) => {
                    return l.id;
                });
            }

            if(typeof obj.lineups !== 'undefined' && typeof obj.lineups.home !== 'undefined'){
                this._lineupHomeOrder = obj.lineups.home.map( (l:any) => {
                    return l.id;
                });
            }

            this.awayPitchers = typeof obj.pitching[aAbbr] !== 'undefined' ? 
            obj.pitching[aAbbr].map((i: any) => {
                const player = new PlayerModel(i);
                player.mlbId = typeof i.id !== 'undefined' ? i.id : '';
                player.name = typeof i.name !== 'undefined' ? i.name : '';
                player.jersey = typeof i.jersey !== 'undefined' ? i.jersey : 0;
                player.pitchingStats = new PitchingStatisticsModel(i);
                return player;
            })
            : [];

            this.homeBatters = typeof obj.batting[hAbbr] !== 'undefined' ? 
            obj.batting[hAbbr].map((i: any) => {
                const player = new PlayerModel();
                player.mlbId = typeof i.id !== 'undefined' ? i.id : '';
                player.name = typeof i.name !== 'undefined' ? i.name : '';
                player.jersey = typeof i.jersey !== 'undefined' ? i.jersey : 0;
                player.battingStats = new BattingStatisticsModel(i);
                return player;
            })
            : [];

            this.homePitchers = typeof obj.pitching[hAbbr] !== 'undefined' ? 
            obj.pitching[hAbbr].map((i: any) => {
                const player = new PlayerModel();
                player.mlbId = typeof i.id !== 'undefined' ? i.id : '';
                player.name = typeof i.name !== 'undefined' ? i.name : '';
                player.jersey = typeof i.jersey !== 'undefined' ? i.jersey : 0;
                player.pitchingStats = new PitchingStatisticsModel(i);
                return player;
            })
            : [];

            if(obj.atbat != 'undefined'){
                this.batter.name = obj.atbat.name;
                this.batter.mlbId = obj.atbat.mlbid;
                this.batter.image = obj.atbat.image;
                this.batter.thumb = obj.atbat.thumbs;
                this.batter.jersey = obj.atbat.jersey;
                this.batter.positionAbbr = obj.atbat.position;

                this.batter.battingStats.avg = obj.atbat.avg;
                this.batter.battingStats.hr = obj.atbat.hr;
                this.batter.battingStats.rbi = obj.atbat.rbi;
                this.batter.battingStats.bb = obj.atbat.bb;
                this.batter.battingStats.h = obj.atbat.h;
                this.batter.battingStats.w = obj.atbat.w;
                this.batter.battingStats.l = obj.atbat.l;

                this.batter.team = obj.atbat.team == 'home' ? this.linescore.homeTeam : this.linescore.awayTeam;
            }

            if(obj.ondeck != 'undefined'){
                this.onDeck.name = obj.ondeck.name;
                this.onDeck.mlbId = obj.ondeck.mlbid;
                this.onDeck.image = obj.ondeck.image;
                this.onDeck.thumb = obj.ondeck.thumbs;
                this.onDeck.jersey = obj.ondeck.jersey;
                this.onDeck.positionAbbr = obj.ondeck.position;

                this.onDeck.battingStats.avg = obj.ondeck.avg;
                this.onDeck.battingStats.hr = obj.ondeck.hr;
                this.onDeck.battingStats.rbi = obj.ondeck.rbi;
                this.onDeck.battingStats.bb = obj.ondeck.bb;
                this.onDeck.battingStats.h = obj.ondeck.h;
                this.onDeck.battingStats.w = obj.ondeck.w;
                this.onDeck.battingStats.l = obj.ondeck.l;

                this.onDeck.team = obj.ondeck.team == 'home' ? this.linescore.homeTeam : this.linescore.awayTeam;
            }

            if(obj.inHole != 'undefined'){
                this.inTheHole.name = obj.inHole.name;
                this.inTheHole.mlbId = obj.inHole.mlbid;
                this.inTheHole.image = obj.inHole.image;
                this.inTheHole.thumb = obj.inHole.thumbs;
                this.inTheHole.jersey = obj.inHole.jersey;
                this.inTheHole.positionAbbr = obj.inHole.position;

                this.inTheHole.battingStats.avg = obj.inHole.avg;
                this.inTheHole.battingStats.hr = obj.inHole.hr;
                this.inTheHole.battingStats.rbi = obj.inHole.rbi;
                this.inTheHole.battingStats.bb = obj.inHole.bb;
                this.inTheHole.battingStats.h = obj.inHole.h;
                this.inTheHole.battingStats.w = obj.inHole.w;
                this.inTheHole.battingStats.l = obj.inHole.l;

                this.inTheHole.team = obj.inHole.team == 'home' ? this.linescore.homeTeam : this.linescore.awayTeam;
            }

            if(obj.pitcher != 'undefined'){
                this.pitcher.name = obj.pitcher.name;
                this.pitcher.mlbId = obj.pitcher.mlbid;
                this.pitcher.image = obj.pitcher.image;
                this.pitcher.thumb = obj.pitcher.thumbs;
                this.pitcher.jersey = obj.pitcher.jersey;
                this.pitcher.positionAbbr = obj.pitcher.position;

                this.pitcher.pitchingStats.era = obj.pitcher.era;
                this.pitcher.pitchingStats.so = obj.pitcher.so;
                this.pitcher.pitchingStats.whip = obj.pitcher.whip;
                this.pitcher.pitchingStats.bb = obj.pitcher.bb;
                this.pitcher.pitchingStats.w = obj.pitcher.w;
                this.pitcher.pitchingStats.l = obj.pitcher.l;

                this.pitcher.team = obj.pitcher.team == 'home' ? this.linescore.homeTeam : this.linescore.awayTeam;
            }
            
            this.activities = typeof obj.gameInfo !== 'undefined' ? obj.gameInfo.map( (i: any) => {
                return {
                    label: i.label,
                    value: i.value
                };
            }): 
            [];
            
        }
    }

    private _getPlayerOrders(order:number[], players){
        const lineup:PlayerModel[] = [];
        for(let id of order){
            for(let p of players){
                if(id == parseInt(p.mlbId)){
                    lineup.push(p);
                    break;
                }
            }
        }
        return lineup;
    }
}